module.exports = __webpack_public_path__ + "img/zizhi240411.993532ab.jpg";